import BulkCarrierChangeApi from "../../services/api/BulkUploadCarrierChangeManager";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk upload carrier change:", err);
}

export const bulkUploadCarrierChange = (payload) => async (dispatch) => {
  try {
    let response = await BulkCarrierChangeApi.bulkUploadCarrierChange(payload);
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};
